export var voteUtil = function (voteValue, likeDislike) {
    var likes = 0;
    var dislikes = 0;
    // likeDislike can be 1 or -1
    // voteValue can be -1 , 0 or 1
    if (likeDislike === 1) {
        if (voteValue === 1) {
            voteValue = 0;
            likes--;
        }
        // If 0 then set 1 & likes++.
        else if (voteValue === 0) {
            voteValue = 1;
            likes++;
        }
        // If -1 then set 1, dislikes-- & likes++
        else {
            voteValue = 1;
            dislikes--;
            likes++;
        }
    }
    else {
        if (voteValue === 1) {
            voteValue = -1;
            likes--;
            dislikes++;
        }
        // If 0 then set -1 & dislikes++.
        else if (voteValue === 0) {
            voteValue = -1;
            dislikes++;
        }
        // If -1 then set 0, dislikes-- & likes++
        else {
            voteValue = 0;
            dislikes--;
        }
    }
    return { voteValue: voteValue, likes: likes, dislikes: dislikes };
};
//# sourceMappingURL=VoteUtil.js.map


//////////////////
// WEBPACK FOOTER
// ../controller/dist/util/VoteUtil.js
// module id = 1304
// module chunks = 0